import ExpServiceProvider, { Data } from '../../expr/api';

export const getSize = (data: Data, attribute: string): number => {
  try {
    const expression = ExpServiceProvider.getExpressionBuilder().sizeOf(attribute);
    const request = {
      expression,
      data,
      variables: {},
    };
    const result = ExpServiceProvider.getExpService().evaluate(request);
    const value = result.value;
    return typeof value === 'number' ? value : -1;
  } catch (error) {
    const dataString = data ? JSON.stringify(data) : 'null';
    console.error(`Failed to getSize(${dataString}, "${attribute}"):`, error);
    return -1;
  }
};
